var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-5 mangerCard bg-white px-7 pt-4" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.isLoading, hasData: _vm.isDataLoaded } },
        [
          !_vm.isManagersExist
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: { subtitle: _vm.emptyListSubtitle, title: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageManagers")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2783177247
                  ),
                },
                [
                  _c("AddContractorToManager", {
                    staticClass: "flex justify-end",
                    attrs: {
                      companyId: _vm.companyId,
                      contractorId: _vm.contractorId,
                      contractorUserId: _vm.contractorUserId,
                      currentUserId: _vm.currentUserId,
                      buttonSize: "xl",
                    },
                    on: { contractorWasAddedToManager: _vm.updateManagerList },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-row items-center justify-between",
                    },
                    [
                      _c("CardBodyItem", {
                        staticClass: "mb-0.5",
                        attrs: {
                          label: "Managers",
                          additionalClass: "customHeading",
                          totalNumber: _vm.managers?.length,
                        },
                      }),
                      _c("AddContractorToManager", {
                        staticClass: "flex justify-end pb-5",
                        attrs: {
                          companyId: _vm.companyId,
                          contractorId: _vm.contractorId,
                          contractorUserId: _vm.contractorUserId,
                          currentUserId: _vm.currentUserId,
                        },
                        on: {
                          contractorWasAddedToManager: _vm.updateManagerList,
                        },
                      }),
                    ],
                    1
                  ),
                  this.managers
                    ? _c(
                        "div",
                        { staticClass: "flex flex-wrap flex-row gap-4" },
                        _vm._l(_vm.managers, function (manager) {
                          return _c("ManagerListCard", {
                            key: manager.id,
                            attrs: {
                              relationId: manager.id,
                              firstName: manager.manager.user.given_name,
                              currentUser: _vm.currentUser,
                              lastName: manager.manager.user.family_name,
                              skills: manager.manager.user.profile.skills,
                              avatar: manager.manager.user.avatar,
                              status: manager.status,
                              manager: manager.manager,
                              profile: manager.manager.user.profile,
                              confirmed: manager.manager.user.confirmed,
                              country: manager.manager.user.profile.country,
                              managerId: manager.id,
                              jobTitle: manager.manager.user.profile.job_title,
                              location: _vm.getLocation(
                                manager.manager.user.profile
                              ),
                            },
                            on: {
                              message: function ($event) {
                                return _vm.message(manager.manager)
                              },
                              managerAccessRemoved: _vm.updateManagerList,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.isDataLoaded
                    ? _c("CardPagination", {
                        attrs: { config: _vm.paginationConfig },
                        on: {
                          "update:config": function ($event) {
                            _vm.paginationConfig = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }